/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregatorsSummaryCollectionResponse } from '../../models/aggregators-summary-collection-response';

export interface AggregatorsSummaryGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  sortDir?: 'ASC' | 'DESC';
  start?: string;
  size?: number;
}

export function aggregatorsSummaryGet(http: HttpClient, rootUrl: string, params: AggregatorsSummaryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AggregatorsSummaryCollectionResponse>> {
  const rb = new RequestBuilder(rootUrl, aggregatorsSummaryGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.query('sortDir', params.sortDir, {});
    rb.query('start', params.start, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AggregatorsSummaryCollectionResponse>;
    })
  );
}

aggregatorsSummaryGet.PATH = '/stores/{storeId}/aggregators-summary';
